import { Fragment, Component } from 'react';
import { connect } from 'react-redux';
import { withSnackbar, WithSnackbarProps } from '@robocorp/components';
import { withTranslation, WithTranslation } from 'react-i18next';

import { AppState } from '~/store';

type StateProps = ReturnType<typeof mapStateToProps>;
type Props = StateProps & WithSnackbarProps & WithTranslation;

class UserMessageHandler extends Component<Props> {
  shouldComponentUpdate(nextProps: Props) {
    const { userMessages } = this.props;

    return nextProps.userMessages.length !== userMessages.length;
  }

  componentDidUpdate() {
    const { userMessages, addSnackbar, t } = this.props;
    if (userMessages.length > 0) {
      const index = userMessages.length - 1;
      const userMessage = userMessages[index];
      if (userMessage && userMessage.showSnackbar !== false) {
        let message = '';

        // Show secondary message only if the translation is present
        if (
          userMessage.translationSubkey &&
          userMessage.translationSubkey !== t(userMessage.translationSubkey)
        ) {
          message = t(userMessage.translationSubkey);

          // Display original Error message, if defined
        } else if (userMessage.errorMessage) {
          message = userMessage.errorMessage;
        }

        addSnackbar({
          message: [t(userMessage.translationKey), message].filter(Boolean).join('. '),
          variant: userMessage.type,
          close: !!userMessage.close,
        });
      }
    }
  }

  render() {
    return <Fragment />;
  }
}

const mapStateToProps = (state: AppState) => {
  return {
    userMessages: state.ui.userMessages.messages,
  };
};

const connected = connect(mapStateToProps)(UserMessageHandler);
const translated = withTranslation()(connected);
export default withSnackbar(translated);
